import { type ComunicazioneDTO } from '@framework/api-client/api/inquiries-compile/schemas/comunicazioneDTO.ts';
import { CommunicationUserTypeTag } from '../CommunicationUserTypeTag.tsx';
import { CommunicationLogic } from '../logic/CommunicationLogic.ts';
import { UserName } from './UserName.tsx';
import { useNormalizedCommunicationUserType } from './useNormalizedCommunicationUserType.ts';

export interface ICommunicationSenderViewProps {
  communication: ComunicazioneDTO | null | undefined;
  compactView?: boolean;
}

/**
 * Attori di una comunicazione
 */
export function CommunicationSenderView(props: ICommunicationSenderViewProps) {
  const { communication, compactView } = props;

  const sender = CommunicationLogic.sender(communication);

  const normalizedCommunicationUserType = useNormalizedCommunicationUserType(
    communication?.tipoComunicazione?.tipoMittente?.codice,
    sender?.idProcedimento,
    // Il mittente non è mai di tipo UFFICIO_COMPETENZA_SECONDARIA
    null,
  );

  if (!communication) return null;

  return (
    <UserName
      name={sender?.denominazione}
      tag={
        compactView ? undefined : (
          <CommunicationUserTypeTag mini {...normalizedCommunicationUserType} />
        )
      }
    />
  );
}
